<template>
  <el-dialog
    :title="title"
    :visible="visible"
    :before-close="closeDialog"
    width="50%">
    <el-table :data="data"
              stripe
              highlight-current-row
              border
              style="width: 100%">
      <el-table-column prop="received_total"
                       label="回款金额汇总"
                       min-width="120">
        <template slot-scope="scope">
          {{scope.row.received_total | seperateThousandsToFixed(2)}}
        </template>
      </el-table-column>
      <el-table-column prop="cnt"
                       label="回款笔数"
                       min-width="120">
      </el-table-column>
      <el-table-column prop="related_total"
                       label="已开票金额"
                       width="190">
        <template slot-scope="scope">
          {{scope.row.related_total | seperateThousandsToFixed(2)}}
        </template>
      </el-table-column>
      <el-table-column prop="remain_total"
                       label="待开票金额"
                       width="190">
        <template slot-scope="scope">
          {{scope.row.remain_total | seperateThousandsToFixed(2)}}
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer"
        class="dialog-footer" >
      <el-button @click="closeDialog">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    title: String,
    data: Array,
  },
  data () {
    return {}
  },
  computed: {
  },
  watch: {},
  created () {},
  mounted () {},
  methods: {
    closeDialog () {
      this.$emit('closeDialog')
    }
  }
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/received-payment/components/PaymentSummaryDialog.vue